export const FILE_REPO = 'FILE_REPO';
export const FILE_SERVICE = 'FILE_SERVICE';
